module.exports = __webpack_public_path__ + "img/DealerIcons-M1-On.a339c30.jpg";